import { ENDPOINTS } from '@/util'
import { toast } from 'sonner'
import { MessagesStorageStorageFileType } from '@/util/enums'
import DOMPurify from 'isomorphic-dompurify'
import { RestSchemas } from '@/contexts/QueryProvider'

type MessagesStorageStorageDetailItem = RestSchemas['Messages.Storage.StorageDetailItem']

const buildQueryString = (params: Record<string, string | number | undefined | null>): string => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      search.append(key, String(value))
    }
  }
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}

export const downloadFile = async (f: MessagesStorageStorageDetailItem, workspaceId: number) => {
  const token = JSON.parse(sessionStorage.getItem('token') ?? '')
  try {
    const query = buildQueryString({
      fileType: MessagesStorageStorageFileType.Template,
      blobName: f.encryptedBlobName,
      subscriptionId: workspaceId,
    })
    const response = await fetch(`${ENDPOINTS.LANDING}/storage/download_file/workspace${query}`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
    if (response.ok) {
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', f.filename ?? 'filename.txt')
      document.body.appendChild(a)
      a.click()
      a.remove()
    } else {
      let errMessage = 'Unknown error'
      if (response.statusText) errMessage = response.statusText
      try {
        const tryJson = await response.json()
        if (tryJson.Message) errMessage = tryJson.Message
      } catch (error) {
        // ignore
      }
      toast.error('Error downloading file')
    }
  } catch (error) {
    toast.error(`Error downloading file: ' + ${DOMPurify.sanitize(`${error}`)}`)
    console.error(DOMPurify.sanitize(`${error}`))
  }
}
